import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {EntitlementPromotionSearchModel} from "../entitlement-promotion-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-entitlement-promotion-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(EntitlementPromotionSearchModel),
        registerSearchControl(EntitlementPromotionMultiSelectSearchControlComponent)
    ]
})
export class EntitlementPromotionMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<EntitlementPromotionSearchModel> {
    constructor(model: EntitlementPromotionSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }
}
